import React, { useState, useEffect } from "react";
import { BrowserRouter as Router, Routes, Route, Navigate } from "react-router-dom";
import LoginPage from "./LoginPage";  // Import your existing LoginPage
import SignupPage from "./SignupPage";  // Import the new SignupPage
import ApplicationsList from "./ApplicationsList";
import ApplicationDetail from "./ApplicationDetail";
import Dashboard from "./Dashboard";
import AnalyzeForm from "./AnalyzeForm";
import WorkItems from "./WorkItems";

function App() {
  const [user, setUser] = useState(null);
  const [loading, setLoading] = useState(true);  // Add loading state

  useEffect(() => {
    // Check if user is logged in
    fetch(`${process.env.REACT_APP_API_URL}/me/`, { credentials: "include" })
      .then(res => res.json())
      .then(data => {
        if (data.username) {
          setUser(data);
        }
      })
      .catch(() => {
        // User is not logged in - this is fine
      })
      .finally(() => {
        setLoading(false);  // Set loading to false when done
      });
  }, []);

  if (loading) {
    return <div>Loading...</div>;
  }

  // Render public routes (signup) even when not authenticated
  return (
    <Router>
      <Routes>
        {/* Public routes */}
        <Route path="/signup" element={<SignupPage />} />
        <Route path="/login" element={user ? <Navigate to="/applications" replace /> : <LoginPage onLogin={setUser} />} />
        
        {/* Protected routes */}
        {user ? (
          <>
            <Route path="/analyzeform" element={<AnalyzeForm user={user} />} />
            <Route path="/applications/:applicationId/workitems" element={<WorkItems user={user} />} />
            <Route path="/applications/:applicationId" element={<ApplicationDetail user={user} />} />
            <Route path="/applications" element={<ApplicationsList user={user} />} />
            <Route path="/dashboard" element={<Dashboard user={user} />} />
            <Route path="/" element={<Navigate to="/applications" replace />} />
            <Route path="*" element={<Navigate to="/applications" replace />} />
          </>
        ) : (
          <Route path="*" element={<Navigate to="/login" replace />} />
        )}
      </Routes>
    </Router>
  );
}

export default App;